module.exports = __webpack_public_path__ + "media/dashboard/assets/images/chat-1-94bcd9883b4aed44c21d52cd1c69737e.svg";